import { createContext } from 'react'

import { createCertificationsStore } from '../store/createStore'

export const CertificationsStoreContext = createContext<
  ReturnType<typeof createCertificationsStore> | undefined
>(undefined)
